import React, { useState, useEffect } from 'react';
import { EventsRepository } from '../services/repository';
import { showSnackbar } from './Snackbar.jsx';
import { DateParser } from '../utils/DateParser';
import './Events.css';

const Events = () => {
  const [events, setEvents] = useState([]);
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    loadEvents();
  }, []);

  useEffect(() => {
    if (!searchQuery.trim()) {
      setFilteredEvents(events);
      return;
    }
    
    const filtered = events.filter(event => 
      event.name?.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredEvents(filtered);
  }, [searchQuery, events]);

  const loadEvents = async () => {
    try {
      setLoading(true);
              const eventsData = await EventsRepository.fetchEvents({ from: new Date() });
      console.log('Events data received:', eventsData);
      console.log('Events data type:', typeof eventsData);
      console.log('Is array:', Array.isArray(eventsData));
      console.log('Events data length:', eventsData?.length);
      
      // Extract events exactly like the original code did
      const eventsArray = eventsData.events || [];
      
      console.log('Final events array:', eventsArray);
      setEvents(eventsArray);
    } catch (error) {
      console.error('Error loading events:', error);
      showSnackbar('Błąd ładowania wydarzeń');
      setEvents([]);
    } finally {
      setLoading(false);
    }
  };





  const groupEventsByDay = (events) => {
    const groups = {};
    if (!Array.isArray(events)) {
      return groups;
    }
    
    events.forEach(event => {
      const start = event.startDate || event.details?.startDate;
      if (start) {
        const dateKey = DateParser.getDateKey(start);
        if (!groups[dateKey]) {
          groups[dateKey] = [];
        }
        groups[dateKey].push(event);
      }
    });
    return groups;
  };

  const handleStartTournament = (event) => {
    window.localStorage.setItem('eventDetails', JSON.stringify(event.details || {}));
    window.location.href = '/tournament-creator';
  };

  const handleEventClick = (event) => {
    if (event.details?.link) {
      window.open(event.details.link, '_blank');
    }
  };

  const renderEventInfo = (event) => {
    const start = event.startDate || event.details?.startDate;
    const end = event.endDate || event.details?.endDate;
    const timeText = DateParser.formatTimeRange(start, end);

    return (
      <div className="event-info">
        <div className="event-name">{event.name}</div>
        <div className="event-time">{timeText}</div>
      </div>
    );
  };

  const renderAttendeeBadge = (event) => {
    const attendees = event.details?.attendees ?? 0;
    const maxAttendees = event.details?.maxAttendees ?? 0;
    let badgeClass = 'badge';
    
    if (maxAttendees === 0 || attendees >= maxAttendees) {
      badgeClass += ' bg-danger';
    } else if (attendees / maxAttendees > 0.6) {
      badgeClass += ' bg-warning text-dark';
    } else {
      badgeClass += ' bg-success';
    }

    return (
      <span className={badgeClass}>
        {attendees}/{maxAttendees}
      </span>
    );
  };

  const renderEventItem = (event) => {
    const lowerName = event.name?.toLowerCase() || '';
    const showButton = lowerName.includes('americano') || lowerName.includes('mexicano');
    const isClickable = event.details?.link;

    return (
      <div 
        key={event.id} 
        className={`list-group-item list-group-item-action d-flex justify-content-between align-items-center ${isClickable ? 'cursor-pointer' : ''}`}
        onClick={isClickable ? () => handleEventClick(event) : undefined}
        style={{ cursor: isClickable ? 'pointer' : 'default' }}
      >
        {renderEventInfo(event)}
        <div className="d-flex align-items-center gap-2">
          {showButton && (
            <button 
              className="btn btn-primary btn-sm"
              onClick={(e) => {
                e.stopPropagation();
                handleStartTournament(event);
              }}
            >
              Rozpocznij
            </button>
          )}
          {renderAttendeeBadge(event)}
        </div>
      </div>
    );
  };

  const renderEvents = () => {
    console.log('renderEvents - filteredEvents:', filteredEvents);
    console.log('renderEvents - filteredEvents type:', typeof filteredEvents);
    console.log('renderEvents - filteredEvents length:', filteredEvents?.length);
    
    if (!Array.isArray(filteredEvents) || filteredEvents.length === 0) {
      console.log('No events to display');
      return <div className="text-center text-muted py-5">
        <i className="bi bi-calendar-x fs-1"></i>
        <p className="mt-3">Brak wydarzeń</p>
      </div>;
    }

    const groupedEvents = groupEventsByDay(filteredEvents);
    console.log('Grouped events:', groupedEvents);
    const sortedDates = DateParser.sortDates(Object.keys(groupedEvents));
    console.log('Sorted dates:', sortedDates);

    if (sortedDates.length === 0) {
      console.log('No grouped events to display');
      return <div className="text-center text-muted py-5">
        <i className="bi bi-calendar-x fs-1"></i>
        <p className="mt-3">Brak wydarzeń</p>
      </div>;
    }

    return sortedDates.map(date => {
      const dayEvents = groupedEvents[date];
      if (!Array.isArray(dayEvents) || dayEvents.length === 0) {
        return null;
      }
      
      const firstEvent = dayEvents[0];
      const start = firstEvent?.startDate || firstEvent?.details?.startDate;
      const formattedDate = start ? DateParser.formatSeconds(start, 'short') : new Date(date).toLocaleDateString();

      return (
        <div key={date} className="mb-4">
          <h5 className="text-uppercase small mb-3" style={{ color: '#ec4899', fontWeight: '600' }}>{formattedDate}</h5>
          <div className="list-group">
            {dayEvents.map(renderEventItem)}
          </div>
        </div>
      );
    });
  };

  if (loading) {
    return <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading events...</span>
      </div>
    </div>;
  }

  return (
    <div className="card shadow-sm">
      <div className="card-body p-4">
        <div style={{ textAlign: 'left', marginBottom: '8px' }}>
          <h3 style={{ color: '#10b981', fontWeight: '700', fontSize: '1.5rem', margin: '0' }}>
            Gdynia Padel Club
          </h3>
        </div>
        <h1 className="text-center mb-4">Wydarzenia</h1>
        <p className="text-center mb-3" style={{ color: '#6ee7b7', fontWeight: '600', fontSize: '1.1rem' }}>
          CO JEST KURWA RAZ DWA TRZY
        </p>
        <div className="row mb-4">
          <div className="col-12">
            <input
              type="text"
              placeholder="Szukaj wydarzenia"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="form-control form-control-lg"
            />
          </div>
        </div>
        <div className="events-list">
          {renderEvents()}
        </div>
      </div>
    </div>
  );
};

export default Events; 